'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.useServiceConsumer = void 0;
var react_redux_1 = require('react-redux');
var useDI_1 = require('./useDI');
function useServiceConsumer(Ctr) {
    var diContext = (0, useDI_1.useDI)();
    var service = diContext.getService(Ctr);
    var store = (0, react_redux_1.useStore)();
    var actions = diContext.createServiceActions(service, store);
    return { service: service, actions: actions };
}
exports.useServiceConsumer = useServiceConsumer;
